import { useInactivityLogout } from "@/hooks/useInactivityLogout";

export const InactivityGuard = () => {
  useInactivityLogout();
  return null;
};
